import { Divider, Typography } from "antd";
import "./terms.css";

const { Title, Paragraph, Text } = Typography;

export const TermsPage = () => {
  return (
    <div className="terms-page">
      <div className="terms-card">
        <Title level={2}>Terms & Conditions</Title>
        <Text type="secondary">Last updated: [Draft]</Text>
        <Paragraph className="terms-disclaimer">
          Draft – not legal advice. This document is a placeholder and must be
          reviewed by legal counsel before use.
        </Paragraph>

        <Divider />

        <section>
          <Title level={4}>1. About OneGrad</Title>
          <Paragraph>
            Describe the company, product scope, and who these Terms apply to.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>2. Eligibility</Title>
          <Paragraph>
            Define who can use the platform, age requirements, and role
            eligibility.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>3. Accounts and Access</Title>
          <Paragraph>
            Explain account creation, responsibility for credentials, and
            account security.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>4. Services and Bookings</Title>
          <Paragraph>
            Outline how sessions are booked, cancelled, or rescheduled, and any
            applicable rules.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>5. Payments and Refunds</Title>
          <Paragraph>
            Describe payment processing, fees, refunds, and chargeback handling.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>6. User Conduct</Title>
          <Paragraph>
            Define acceptable use, prohibited behavior, and content standards.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>7. Content and Intellectual Property</Title>
          <Paragraph>
            Clarify ownership of content, licenses granted, and IP protections.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>8. Confidentiality and Privacy</Title>
          <Paragraph>
            Summarize privacy expectations and link to the Privacy Policy.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>9. Disclaimers</Title>
          <Paragraph>
            Provide standard disclaimers about outcomes, advice, and service
            availability.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>10. Limitation of Liability</Title>
          <Paragraph>
            Define liability limits and exclusions to protect the company.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>11. Indemnification</Title>
          <Paragraph>
            State user obligations to indemnify the company for misuse.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>12. Termination</Title>
          <Paragraph>
            Explain termination rights and effect of termination.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>13. Governing Law</Title>
          <Paragraph>
            Specify jurisdiction, governing law, and dispute resolution.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>14. Changes to These Terms</Title>
          <Paragraph>
            Explain how updates are communicated and when they take effect.
          </Paragraph>
        </section>

        <section>
          <Title level={4}>15. Contact</Title>
          <Paragraph>
            Provide a support email or contact address for legal inquiries.
          </Paragraph>
        </section>
      </div>
    </div>
  );
};
